var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstImageProperty } from '@shapeable/utils';
var cls = classNames('image-entity-background');
import { breakpoints, theme } from '@shapeable/theme';
import { trimEnd } from 'lodash';
import { applyAspectRatio } from '../elements/responsive-container';
import { ImageEntityInfoTooltip } from './image-entity-info-tooltip';
export var ImageEntityBackgroundDefaultProps = {
  bodyStyle: {},
  style: {},
  showInfo: false,
  autoOverlayMinLightness: 120,
  autoOverlayMaxOpacity: 0.6
};
// -------- Styles -------->
var topBG = function (value) {
  if (value) {
    return "".concat(trimEnd(value, ','), ", ");
  }
  return '';
};
var IMAGE = function (key, topKey) {
  return function (props) {
    return props.entity && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: ", " url(", ");\n"], ["\n  background-image: ", " url(", ");\n"])), topBG(props[topKey]), props.entity[key] && props.entity[key].url || props.entity.image && props.entity.image.url);
  };
};
var IMAGE_SET = function (key, topKey) {
  return function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return (((_b = (_a = props.entity) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.url) || ((_d = (_c = props.entity) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.url)) && (((_f = (_e = props.entity) === null || _e === void 0 ? void 0 : _e[key]) === null || _f === void 0 ? void 0 : _f.url2x) || ((_h = (_g = props.entity) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.url2x)) && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image: image-set(\n    ", " url(", ") 1x,\n    ", " url(", ") 2x\n  );\n  \n"], ["\n  background-image: image-set(\n    ", " url(", ") 1x,\n    ", " url(", ") 2x\n  );\n  \n"])), topBG(props[topKey]), ((_k = (_j = props.entity) === null || _j === void 0 ? void 0 : _j[key]) === null || _k === void 0 ? void 0 : _k.url2x) || ((_m = (_l = props.entity) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.url2x), topBG(props[topKey]), ((_p = (_o = props.entity) === null || _o === void 0 ? void 0 : _o[key]) === null || _p === void 0 ? void 0 : _p.url2x) || ((_r = (_q = props.entity) === null || _q === void 0 ? void 0 : _q.image) === null || _r === void 0 ? void 0 : _r.url2x));
  };
};
var IMAGES = function (key, topKey) {
  return function (props) {
    return !!(props.items || []).length && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-image:  ", " ", ";\n"], ["\n  background-image:  ", " ", ";\n"])), topBG(props[topKey]), (props.items || []).map(function (entity) {
      return "url(".concat(entity[key] && entity[key].url || entity.image && entity.image.url, ")");
    }).join(","));
  };
};
var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    box-sizing: border-box;\n\n    ", "\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    position: relative;\n    display: flex;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    box-sizing: border-box;\n\n    ", "\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), function (_a) {
    var aspectRatio = _a.aspectRatio;
    return aspectRatio && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: relative;\n      overflow: hidden;\n    "], ["\n      position: relative;\n      overflow: hidden;\n    "])));
  }, applyAspectRatio('base'), IMAGE('portraitImage', 'baseTopImageStyles'), IMAGE_SET('portraitImage', 'baseTopImageStyles'), IMAGES('portraitImage', 'baseTopImageStyles')),
  landscape: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('landscape'), IMAGE('landscapeImage', 'landscapeTopImageStyles'), IMAGE_SET('landscapeImage', 'landscapeTopImageStyles'), IMAGES('landscapeImage', 'landscapeTopImageStyles')),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('tablet'), IMAGE('tabletImage', 'tabletTopImageStyles'), IMAGE_SET('tabletImage', 'tabletTopImageStyles'), IMAGES('tabletImage', 'tabletTopImageStyles')),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('desktop'), IMAGE('image', 'desktopTopImageStyles'), IMAGE_SET('image', 'desktopTopImageStyles'), IMAGES('image', 'desktopTopImageStyles')),
  desktopLarge: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('large'), applyAspectRatio('desktopLarge'), IMAGE('largeImage', 'desktopLargeTopImageStyles'), IMAGE_SET('largeImage', 'desktopLargeTopImageStyles'), IMAGES('largeImage', 'desktopLargeTopImageStyles')),
  desktopFullHD: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('desktopFullHD'), IMAGE('largeImage', 'desktopLargeTopImageStyles'), IMAGE_SET('largeImage', 'desktopLargeTopImageStyles'), IMAGES('largeImage', 'desktopLargeTopImageStyles')),
  last: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    background-blend-mode: multiply;\n  "], ["\n    background-blend-mode: multiply;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n    transition: background-color 0.1s;\n    background-color: rgba(0, 0, 0, 0);\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n    transition: background-color 0.1s;\n    background-color: rgba(0, 0, 0, 0);\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var padding = _a.padding;
    return padding && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), padding);
  }, function (_a) {
    var unitPadding = _a.unitPadding;
    return unitPadding && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(unitPadding));
  }, function (_a) {
    var overlayColor = _a.overlayColor;
    return overlayColor && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), overlayColor);
  })
});
var InfoTooltipStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: absolute;\n    left: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "], ["\n    position: absolute;\n    left: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "])), theme.UNIT(4), theme.UNIT(4)),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    left: ", ";\n    bottom: ", ";\n  "], ["\n    left: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(7), theme.UNIT(7)),
  desktop: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    left: ", ";\n    bottom: ", ";\n  "], ["\n    left: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(8), theme.UNIT(8))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  InfoTooltip: styled(ImageEntityInfoTooltip).attrs(cls.attr('info-tooltip'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), InfoTooltipStyles)
};
export var ImageEntityBackground = function (props) {
  var className = props.className,
    aspectRatio = props.aspectRatio,
    entity = props.entity,
    autoOverlayMaxOpacity = props.autoOverlayMaxOpacity,
    autoOverlayMinLightness = props.autoOverlayMinLightness,
    items = props.items,
    useAutoOverlay = props.useAutoOverlay,
    _a = props.infoTooltipProps,
    infoTooltipProps = _a === void 0 ? {} : _a,
    showInfo = props.showInfo,
    children = props.children,
    onClick = props.onClick,
    unitPadding = props.unitPadding,
    bodyStyle = props.bodyStyle,
    style = props.style,
    padding = props.padding,
    overlayColor = props.overlayColor;
  var containerProps = {
    entity: entity,
    items: items
  };
  var image = firstImageProperty(entity, ['image']);
  var imageRef = useRef(null);
  var canvasRef = useRef(null);
  var _b = __read(useState(null), 2),
    lightness = _b[0],
    setLightness = _b[1];
  var lightnessToAlphaHex = function (lightness) {
    // Normalize the lightness to a scale from 0 to 1 (0 is dark, 1 is light)
    var normalizedLightness = Math.min(Math.max(lightness / 255, 0), 1);
    // Invert and map to a range from 0 to 170 (0xAA in decimal)
    var alphaValue = Math.round((1 - normalizedLightness) * (autoOverlayMaxOpacity * 255));
    // Convert to a two-digit hex value
    var hexAlpha = alphaValue.toString(16).padStart(2, '0').toUpperCase();
    return hexAlpha;
  };
  useEffect(function () {
    if (useAutoOverlay) {
      var calculateImageLightness_1 = function () {
        var image = imageRef.current;
        image.crossOrigin = 'anonymous';
        var canvas = canvasRef.current;
        if (!image || !canvas) return;
        var context = canvas.getContext('2d');
        if (!context) return;
        // Set canvas dimensions to match the image
        canvas.width = image.width;
        canvas.height = image.height;
        // Draw the image onto the canvas
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        // Get image data
        var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        var colorSum = 0;
        // Loop through every pixel
        for (var i = 0; i < data.length; i += 4) {
          var r = data[i];
          var g = data[i + 1];
          var b = data[i + 2];
          // Calculate brightness for this pixel
          var brightness = 0.299 * r + 0.587 * g + 0.114 * b;
          colorSum += brightness;
        }
        // Average brightness across all pixels
        var avgBrightness = colorSum / (canvas.width * canvas.height);
        setLightness(avgBrightness);
      };
      // Add event listener to calculate lightness when the image loads
      var image_1 = imageRef.current;
      if (image_1) {
        image_1.addEventListener('load', calculateImageLightness_1);
      }
      // Clean up event listener
      return function () {
        if (image_1) {
          image_1.removeEventListener('load', calculateImageLightness_1);
        }
      };
    }
  }, [image === null || image === void 0 ? void 0 : image.url]); // Re-run when src changes
  var baseTopImageStyles = props.baseTopImageStyles,
    landscapeTopImageStyles = props.landscapeTopImageStyles,
    tabletTopImageStyles = props.tabletTopImageStyles,
    desktopTopImageStyles = props.desktopTopImageStyles,
    desktopLargeTopImageStyles = props.desktopLargeTopImageStyles;
  var topProps = {
    baseTopImageStyles: baseTopImageStyles,
    landscapeTopImageStyles: landscapeTopImageStyles,
    tabletTopImageStyles: tabletTopImageStyles,
    desktopTopImageStyles: desktopTopImageStyles,
    desktopLargeTopImageStyles: desktopLargeTopImageStyles
  };
  return React.createElement(My.Container, __assign({}, containerProps, topProps, {
    onClick: onClick,
    style: style,
    aspectRatio: aspectRatio,
    className: cls.name(className)
  }), useAutoOverlay && React.createElement(React.Fragment, null, React.createElement("canvas", {
    ref: canvasRef,
    style: {
      display: 'none'
    }
  }), React.createElement("img", {
    ref: imageRef,
    src: image === null || image === void 0 ? void 0 : image.url,
    style: {
      visibility: 'hidden',
      position: 'absolute',
      left: '-100000px',
      top: 0
    }
  })), showInfo && React.createElement(My.InfoTooltip, __assign({
    entity: entity
  }, infoTooltipProps)), React.createElement(My.Body, {
    style: bodyStyle,
    unitPadding: unitPadding,
    padding: padding,
    overlayColor: useAutoOverlay && lightness && lightness > autoOverlayMinLightness ? "#000000".concat(lightnessToAlphaHex(lightness)) : overlayColor
  }, children));
};
ImageEntityBackground.defaultProps = ImageEntityBackgroundDefaultProps;
ImageEntityBackground.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;